// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.standalone_container {
  text-align: left;
}
.standalone_header {
  position: absolute;
  /* width: 214px; */
  height: 24px;
  /* left: 285px; */
  top: 82px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  text-transform: capitalize;

  color: #001a11;
}
.standalone_para {
  position: absolute;
  /* width: 427px; */
  height: 17px;
  /* left: 286px; */
  top: 112px;

  font-family: "Inter";
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  color: #000000;
}
.standalone_table {
  width: 96%;
border-radius: 5px 5px 0px 0px;
margin-left: 2%;
margin-right: 2%;
max-height: 75vh;
/* overflow-y: auto; */

}
.audit-log-table {
  width: 100%;
border-radius: 5px 5px 0px 0px;
max-height: 75vh;
margin-top: 1%;
/* overflow-y: auto; */

}
.standalone_search {
  box-sizing: border-box;

/* position: absolute; */
width: 220px;
height: 40px;
/* left: -40px; */
/* top: 73px; */

  background: #ffffff;
  border: 1px solid #acacac;
  border-radius: 5px;
}
.messageflows_search {
  box-sizing: border-box;

position: absolute;
width: 220px;
height: 40px;
left: -15px;
top: 73px;

  background: #ffffff;
  border: 1px solid #acacac;
  border-radius: 5px;
}
.standalone_button {
  box-sizing: border-box;

  /* Auto layout */

display: flex;
flex-direction: row;
align-items: center;
/* padding: 13px 10px; */
gap: 0px;

/* position: absolute; */
width: 79.12px;
height: 40px;
/* left: 700px; */
/* top: 73px; */

  background: #ffffff;
  border: 1px solid #009966;
  border-radius: 5px;
}
.messageflows_button{
  /* display: flex; */
flex-direction: row;
align-items: center;
/* padding: 13px 10px;
gap: 8px; */
/* position: absolute; */
/* width: 94px; */
min-width: 100px;
height: 40px;
/* left: 1242px;
top: 183px; */

background: #FFFFFF;
border: 1px solid #009966;
border-radius: 5px;
}
.standalone_button_text {
  width: 31px;
  height: 19px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.03em;

  color: #009966;

  /* Inside auto layout */

/* Inside auto layout */

flex: none;
order: 2;
flex-grow: 0;
text-transform: none;
margin-top: 14px;
}
.table-row-light {
    background-color: #F5F7FA;
}
.table-row-dark {
    background-color: #FFFFFF;
}
.ant-table-thead .ant-table-cell {
    background-color: rgb(0, 0, 0);
  }
  /* .checkbox-red .ant-checkbox-checked .ant-checkbox-inner,
  
    .ant-checkbox-inner
    .ant-checkbox-wrapper 
    .ant-checkbox-wrapper:hover .ant-checkbox-border                   .ant-checkbox-input:focus .ant-table-thead{
    background-color: rgb(199, 195, 195) !important;
    border-color: green !important;
    color: green !important;
    fill: red !important;
    
  }
  
  .checkbox-red .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: green !important;
    color: green !important;
    fill: red !important;
  }
  .ant-checkbox-indeterminate{
    color: green;
  } */
  .ant-table {
    font-size: 9px;
    /* height: 5px; */
    padding: 4px;
    
  }
  .ant-table-tbody > tr > td {
    padding: 0px;
  }
  .ant-table-thead > tr > th {
    height: 5px;
    padding: 4px;
    background-color: #000000;
  }
  .testRuns_button{
    box-sizing: border-box;

  /* Auto layout */

display: flex;
flex-direction: row;
align-items: center;
/* padding: 13px 10px; */
gap: 0px;

position: absolute;
width: 93px;
height: 40px;
left: 700px;
top: 73px;

  background: #ffffff;
  border: 1px solid #009966;
  border-radius: 5px;

}
.payapt-expanded-row {
  font-weight: 600 !important;
}
.review-column, .review-column-checked {
  margin-left: 5%;
  font-size: 14px;
}
.review-column {
  font-weight: 400;
  color: var(--disabled-text-color);
}
.review-column-checked {
  font-weight: 600;
  color: var(--primary-color);
}
.testruns-results-progress{
  width: 65px;
height: 15px;

font-family: 'Inter';
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 15px;
/* identical to box height */


color: #F2C046;


/* Inside auto layout */

flex: none;
order: 1;
flex-grow: 0;
}
.testruns-results-failed{
  width: 35px;
height: 15px;

font-family: 'Inter';
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 15px;
/* identical to box height */


color: #D65442;


/* Inside auto layout */

flex: none;
order: 1;
flex-grow: 0;
}
.testruns-results-success{
  width: 49px;
height: 15px;

font-family: 'Inter';
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 15px;
/* identical to box height */


color: #549E56;


/* Inside auto layout */

flex: none;
order: 1;
flex-grow: 0;
}
.testruns-results-pending{
  width: 49px;
  height: 15px;
  
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */
  
  
  color: #878787;
  
  
  /* Inside auto layout */
  
  flex: none;
  order: 1;
  flex-grow: 0;
}
.hourglass-icon{
  color:'#F2C046';
  width: 20px;
  height: 30px;
}
/* thead tr th:first-child .ant-checkbox-inner::after {
  position: relative !important;
  color: black !important;
  border: none !important;
  width: 25px !important;
  height: 25px !important;
  background: transparent !important;
  transform: none !important;
  top: 0% !important;
  content: '-'  !important;
} */

.sharp-background {
  justify-content: space-between;
  display: flex;
  width: 90%;
  height: 45px;
  background-color: #f5f7fa;
  color: #000000;
  padding: 10px;
  position: relative;
  /* margin: 40px; */
  /* float: left; */
  border-radius: 5px;
  flex-direction: row;
  /* background: #F5F7FA;
border: 1px solid #F0F0F0;
border-radius: 5px;
font-size: large;
width: 310px;
height: 60px;
padding-right: 100px;
padding-left: 10px;
padding-top: 5px;
padding-bottom: 5px; */
}
.tri-background {
  /* position: absolute; */
  width: 9px;
  height: 10px;
  left: 612px;
  top: 367px;

  /* background: #C6CBD1; */
  border-radius: 1px;
}

.sharp-background:after {
  content: ' ';
  width: 9px;
  height: 10px;
  border-top: 15px solid transparent;
  border-right: none;
  border-left: 15px solid #f5f7fa;
  border-bottom: 15px solid transparent;
}
.sharp-background.arrow-right:after {
  content: ' ';
  position: absolute;
  right: -8px;
  top: 15px;
  border-top: 8px solid transparent;
  border-right: none;
  border-left: 8px solid #f5f7fa;
  border-bottom: 8px solid transparent;
}
.without-sharp {
  justify-content: space-between;
  width: 90%;
  height: auto;
  padding: 10px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  display: flex;
}
.css-18lkw67-MuiSwitch-track{
  background-color: #009966 !important;
  opacity: 1 !important;
}
.standalone_table .ant-form-item-explain {
  position: absolute;
  top: 75%;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/homeScreens/homeScreen.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,SAAS;;EAET,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;;EAE1B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,UAAU;;EAEV,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;;EAE5B,cAAc;AAChB;AACA;EACE,UAAU;AACZ,8BAA8B;AAC9B,eAAe;AACf,gBAAgB;AAChB,gBAAgB;AAChB,sBAAsB;;AAEtB;AACA;EACE,WAAW;AACb,8BAA8B;AAC9B,gBAAgB;AAChB,cAAc;AACd,sBAAsB;;AAEtB;AACA;EACE,sBAAsB;;AAExB,wBAAwB;AACxB,YAAY;AACZ,YAAY;AACZ,iBAAiB;AACjB,eAAe;;EAEb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,sBAAsB;;AAExB,kBAAkB;AAClB,YAAY;AACZ,YAAY;AACZ,WAAW;AACX,SAAS;;EAEP,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,sBAAsB;;EAEtB,gBAAgB;;AAElB,aAAa;AACb,mBAAmB;AACnB,mBAAmB;AACnB,wBAAwB;AACxB,QAAQ;;AAER,wBAAwB;AACxB,cAAc;AACd,YAAY;AACZ,iBAAiB;AACjB,eAAe;;EAEb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB,mBAAmB;AACnB,mBAAmB;AACnB;WACW;AACX,wBAAwB;AACxB,iBAAiB;AACjB,gBAAgB;AAChB,YAAY;AACZ;aACa;;AAEb,mBAAmB;AACnB,yBAAyB;AACzB,kBAAkB;AAClB;AACA;EACE,WAAW;EACX,YAAY;;EAEZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;;EAEtB,cAAc;;EAEd,uBAAuB;;AAEzB,uBAAuB;;AAEvB,UAAU;AACV,QAAQ;AACR,YAAY;AACZ,oBAAoB;AACpB,gBAAgB;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,8BAA8B;EAChC;EACA;;;;;;;;;;;;;;;;;;;;;KAqBG;EACH;IACE,cAAc;IACd,iBAAiB;IACjB,YAAY;;EAEd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,sBAAsB;;EAExB,gBAAgB;;AAElB,aAAa;AACb,mBAAmB;AACnB,mBAAmB;AACnB,wBAAwB;AACxB,QAAQ;;AAER,kBAAkB;AAClB,WAAW;AACX,YAAY;AACZ,WAAW;AACX,SAAS;;EAEP,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;;AAEpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb,YAAY;;AAEZ,oBAAoB;AACpB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,4BAA4B;;;AAG5B,cAAc;;;AAGd,uBAAuB;;AAEvB,UAAU;AACV,QAAQ;AACR,YAAY;AACZ;AACA;EACE,WAAW;AACb,YAAY;;AAEZ,oBAAoB;AACpB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,4BAA4B;;;AAG5B,cAAc;;;AAGd,uBAAuB;;AAEvB,UAAU;AACV,QAAQ;AACR,YAAY;AACZ;AACA;EACE,WAAW;AACb,YAAY;;AAEZ,oBAAoB;AACpB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,4BAA4B;;;AAG5B,cAAc;;;AAGd,uBAAuB;;AAEvB,UAAU;AACV,QAAQ;AACR,YAAY;AACZ;AACA;EACE,WAAW;EACX,YAAY;;EAEZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;;;EAG5B,cAAc;;;EAGd,uBAAuB;;EAEvB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;;;;;;;;;;GAUG;;AAEH;EACE,8BAA8B;EAC9B,aAAa;EACb,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB;;;;;;;;;sBASoB;AACtB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,UAAU;;EAEV,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iCAAiC;EACjC,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;AACtC;AACA;EACE,8BAA8B;EAC9B,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;AACjB","sourcesContent":[".standalone_container {\n  text-align: left;\n}\n.standalone_header {\n  position: absolute;\n  /* width: 214px; */\n  height: 24px;\n  /* left: 285px; */\n  top: 82px;\n\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  text-transform: capitalize;\n\n  color: #001a11;\n}\n.standalone_para {\n  position: absolute;\n  /* width: 427px; */\n  height: 17px;\n  /* left: 286px; */\n  top: 112px;\n\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n  /* identical to box height */\n\n  color: #000000;\n}\n.standalone_table {\n  width: 96%;\nborder-radius: 5px 5px 0px 0px;\nmargin-left: 2%;\nmargin-right: 2%;\nmax-height: 75vh;\n/* overflow-y: auto; */\n\n}\n.audit-log-table {\n  width: 100%;\nborder-radius: 5px 5px 0px 0px;\nmax-height: 75vh;\nmargin-top: 1%;\n/* overflow-y: auto; */\n\n}\n.standalone_search {\n  box-sizing: border-box;\n\n/* position: absolute; */\nwidth: 220px;\nheight: 40px;\n/* left: -40px; */\n/* top: 73px; */\n\n  background: #ffffff;\n  border: 1px solid #acacac;\n  border-radius: 5px;\n}\n.messageflows_search {\n  box-sizing: border-box;\n\nposition: absolute;\nwidth: 220px;\nheight: 40px;\nleft: -15px;\ntop: 73px;\n\n  background: #ffffff;\n  border: 1px solid #acacac;\n  border-radius: 5px;\n}\n.standalone_button {\n  box-sizing: border-box;\n\n  /* Auto layout */\n\ndisplay: flex;\nflex-direction: row;\nalign-items: center;\n/* padding: 13px 10px; */\ngap: 0px;\n\n/* position: absolute; */\nwidth: 79.12px;\nheight: 40px;\n/* left: 700px; */\n/* top: 73px; */\n\n  background: #ffffff;\n  border: 1px solid #009966;\n  border-radius: 5px;\n}\n.messageflows_button{\n  /* display: flex; */\nflex-direction: row;\nalign-items: center;\n/* padding: 13px 10px;\ngap: 8px; */\n/* position: absolute; */\n/* width: 94px; */\nmin-width: 100px;\nheight: 40px;\n/* left: 1242px;\ntop: 183px; */\n\nbackground: #FFFFFF;\nborder: 1px solid #009966;\nborder-radius: 5px;\n}\n.standalone_button_text {\n  width: 31px;\n  height: 19px;\n\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n  letter-spacing: 0.03em;\n\n  color: #009966;\n\n  /* Inside auto layout */\n\n/* Inside auto layout */\n\nflex: none;\norder: 2;\nflex-grow: 0;\ntext-transform: none;\nmargin-top: 14px;\n}\n.table-row-light {\n    background-color: #F5F7FA;\n}\n.table-row-dark {\n    background-color: #FFFFFF;\n}\n.ant-table-thead .ant-table-cell {\n    background-color: rgb(0, 0, 0);\n  }\n  /* .checkbox-red .ant-checkbox-checked .ant-checkbox-inner,\n  \n    .ant-checkbox-inner\n    .ant-checkbox-wrapper \n    .ant-checkbox-wrapper:hover .ant-checkbox-border                   .ant-checkbox-input:focus .ant-table-thead{\n    background-color: rgb(199, 195, 195) !important;\n    border-color: green !important;\n    color: green !important;\n    fill: red !important;\n    \n  }\n  \n  .checkbox-red .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n  .ant-checkbox:hover .ant-checkbox-inner,\n  .ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: green !important;\n    color: green !important;\n    fill: red !important;\n  }\n  .ant-checkbox-indeterminate{\n    color: green;\n  } */\n  .ant-table {\n    font-size: 9px;\n    /* height: 5px; */\n    padding: 4px;\n    \n  }\n  .ant-table-tbody > tr > td {\n    padding: 0px;\n  }\n  .ant-table-thead > tr > th {\n    height: 5px;\n    padding: 4px;\n    background-color: #000000;\n  }\n  .testRuns_button{\n    box-sizing: border-box;\n\n  /* Auto layout */\n\ndisplay: flex;\nflex-direction: row;\nalign-items: center;\n/* padding: 13px 10px; */\ngap: 0px;\n\nposition: absolute;\nwidth: 93px;\nheight: 40px;\nleft: 700px;\ntop: 73px;\n\n  background: #ffffff;\n  border: 1px solid #009966;\n  border-radius: 5px;\n\n}\n.payapt-expanded-row {\n  font-weight: 600 !important;\n}\n.review-column, .review-column-checked {\n  margin-left: 5%;\n  font-size: 14px;\n}\n.review-column {\n  font-weight: 400;\n  color: var(--disabled-text-color);\n}\n.review-column-checked {\n  font-weight: 600;\n  color: var(--primary-color);\n}\n.testruns-results-progress{\n  width: 65px;\nheight: 15px;\n\nfont-family: 'Inter';\nfont-style: normal;\nfont-weight: 500;\nfont-size: 12px;\nline-height: 15px;\n/* identical to box height */\n\n\ncolor: #F2C046;\n\n\n/* Inside auto layout */\n\nflex: none;\norder: 1;\nflex-grow: 0;\n}\n.testruns-results-failed{\n  width: 35px;\nheight: 15px;\n\nfont-family: 'Inter';\nfont-style: normal;\nfont-weight: 500;\nfont-size: 12px;\nline-height: 15px;\n/* identical to box height */\n\n\ncolor: #D65442;\n\n\n/* Inside auto layout */\n\nflex: none;\norder: 1;\nflex-grow: 0;\n}\n.testruns-results-success{\n  width: 49px;\nheight: 15px;\n\nfont-family: 'Inter';\nfont-style: normal;\nfont-weight: 500;\nfont-size: 12px;\nline-height: 15px;\n/* identical to box height */\n\n\ncolor: #549E56;\n\n\n/* Inside auto layout */\n\nflex: none;\norder: 1;\nflex-grow: 0;\n}\n.testruns-results-pending{\n  width: 49px;\n  height: 15px;\n  \n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 15px;\n  /* identical to box height */\n  \n  \n  color: #878787;\n  \n  \n  /* Inside auto layout */\n  \n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n.hourglass-icon{\n  color:'#F2C046';\n  width: 20px;\n  height: 30px;\n}\n/* thead tr th:first-child .ant-checkbox-inner::after {\n  position: relative !important;\n  color: black !important;\n  border: none !important;\n  width: 25px !important;\n  height: 25px !important;\n  background: transparent !important;\n  transform: none !important;\n  top: 0% !important;\n  content: '-'  !important;\n} */\n\n.sharp-background {\n  justify-content: space-between;\n  display: flex;\n  width: 90%;\n  height: 45px;\n  background-color: #f5f7fa;\n  color: #000000;\n  padding: 10px;\n  position: relative;\n  /* margin: 40px; */\n  /* float: left; */\n  border-radius: 5px;\n  flex-direction: row;\n  /* background: #F5F7FA;\nborder: 1px solid #F0F0F0;\nborder-radius: 5px;\nfont-size: large;\nwidth: 310px;\nheight: 60px;\npadding-right: 100px;\npadding-left: 10px;\npadding-top: 5px;\npadding-bottom: 5px; */\n}\n.tri-background {\n  /* position: absolute; */\n  width: 9px;\n  height: 10px;\n  left: 612px;\n  top: 367px;\n\n  /* background: #C6CBD1; */\n  border-radius: 1px;\n}\n\n.sharp-background:after {\n  content: ' ';\n  width: 9px;\n  height: 10px;\n  border-top: 15px solid transparent;\n  border-right: none;\n  border-left: 15px solid #f5f7fa;\n  border-bottom: 15px solid transparent;\n}\n.sharp-background.arrow-right:after {\n  content: ' ';\n  position: absolute;\n  right: -8px;\n  top: 15px;\n  border-top: 8px solid transparent;\n  border-right: none;\n  border-left: 8px solid #f5f7fa;\n  border-bottom: 8px solid transparent;\n}\n.without-sharp {\n  justify-content: space-between;\n  width: 90%;\n  height: auto;\n  padding: 10px;\n  background: #ffffff;\n  border: 1px solid #f0f0f0;\n  border-radius: 5px;\n  display: flex;\n}\n.css-18lkw67-MuiSwitch-track{\n  background-color: #009966 !important;\n  opacity: 1 !important;\n}\n.standalone_table .ant-form-item-explain {\n  position: absolute;\n  top: 75%;\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
